import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { EntityStatus } from "shared/global/enums";
import { StoreMiddlewareEntity } from "shared/global/entities";
import { TradingStatusData } from "shared/symbol/types";
import { AccountState } from "./types";
import { thunkService } from "services";

class AccountThunk {
    /** Description: Adds the "getLoginInformations" method cases to extra reducers in the Account Slice.  */
    public addLoginInformationsCase = (builder: ActionReducerMapBuilder<AccountState>) => {
        // Event: onPending
        builder.addCase(thunkService.account.getLoginInformations.pending, (state, action) => {
            state.loginInformations = new StoreMiddlewareEntity({
                data: {
                    defaultWatchListSymbols: new Array<string>(), tenantSummary: null
                },
                status: EntityStatus.PENDING,
                updateTime: Date.now(),
                message : null
            })
        })

        // Event: onRejected
        builder.addCase(thunkService.account.getLoginInformations.rejected, (state, action) => {
            state.loginInformations = new StoreMiddlewareEntity({
                data: { defaultWatchListSymbols: [], tenantSummary:null },
                status: EntityStatus.FAILED,
                updateTime: Date.now(),
                message: action.error.message!
            })
        })

        // Event: onFulfilled
        builder.addCase(thunkService.account.getLoginInformations.fulfilled, (state, action) => {

            const { user, group, tradingAccountInfo, tradingViewTimeZone, tradingPlatformAvailable, ...loginInformations } = action.payload as any;

            state.user = user;  
            state.loginInformations = new StoreMiddlewareEntity({
                data: loginInformations,
                status: EntityStatus.SUCCEEDED,
                updateTime: Date.now(),
                message: null
            })

            if (tradingAccountInfo) {
                const tradingStatusData = {
                    balance: tradingAccountInfo.balance,
                    credit: tradingAccountInfo.credit,
                    equity: tradingAccountInfo.equity,
                    margin: tradingAccountInfo.margin,
                    marginFree: tradingAccountInfo.marginFree,
                    marginLevel: tradingAccountInfo.marginLevel,
                    volume: tradingAccountInfo.volume,
                    profit: tradingAccountInfo.equity - tradingAccountInfo.balance,
                }

                state.tradingStatus = tradingStatusData;
                state.tradingViewTimeZone = tradingViewTimeZone;
                state.tradingPlatformAvailable = tradingPlatformAvailable;
            }
        })

        /// TODO: should be fixed
        //////////////////////////////////////
        builder.addCase(thunkService.account.getTradingAccountInfo.fulfilled, (state, action) => {
            const payload = action.payload as any;
            const tradingAccountInfo: TradingStatusData = payload.tradingAccountInfo;

            if (tradingAccountInfo) {
                const tradingStatusData = {
                    balance: tradingAccountInfo.balance,
                    credit: tradingAccountInfo.credit,
                    equity: tradingAccountInfo.equity,
                    margin: tradingAccountInfo.margin,
                    marginFree: tradingAccountInfo.marginFree,
                    marginLevel: tradingAccountInfo.marginLevel,
                    volume: tradingAccountInfo.volume,
                    profit: tradingAccountInfo.equity - tradingAccountInfo.balance,
                }
                
                state.tradingStatus = tradingStatusData;
                state.tradingPlatformAvailable = payload.tradingPlatformAvailable;
                state.tradingViewTimeZone = payload.tradingViewTimeZone;
            }
        });
    }
}

const accountThunk = new AccountThunk();
export default accountThunk;